import {IntermediatePart} from "../../intermediatePart";
import { Vanity } from "../../parts/vanity";
import {createParentPositions, METADATA, SIDE_POSITIONS, LOOK_ROOM_TYPES} from "../../constants";
import {getSkuWithoutDot, removeLookPointFor} from "../../../lookNavigation/lookFunctions2";
import {navFeatureCLick} from "../../../lookNavigation/lookFunctions";
import store from "../../../../../store";
import {getCurrentRoomType} from "../../../../appLayout";

export default class VanityFaucet extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'vanity_faucet';
    this.partName = 'Faucet';
    this.homePageTitle = 'Faucets';
    this.translateId = "visualizer.bathroom.vanity.vanity_faucet";
    this.visible = [Vanity.Types.Custom];
    this.useMatchesFailedNavigation = true;
    // this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  load(dbFeature) {
    if (dbFeature.filterValueIDs && Array.isArray(dbFeature.filterValueIDs["27"])) { // Collection
      const concettoTMIndex = dbFeature.filterValueIDs["27"].findIndex(filterValueId => filterValueId === 10410);
      if (concettoTMIndex > -1) { // here we remove Concetto™ filter as it comes from the feed, we can't remove if rome dashboard
        // we replace it to "Concetto"
        dbFeature.filterValueIDs["27"].includes(9755)
          ? dbFeature.filterValueIDs["27"].splice(concettoTMIndex, 1)
          : dbFeature.filterValueIDs["27"].splice(concettoTMIndex, 1, 9755)
      }
    }
    if (!dbFeature.metaData["MountType"]) {
      dbFeature.metaData["MountType"] = [METADATA.Inner]
      // } else if(dbFeature.metaData["MountType"].includes(METADATA.Outer) && !dbFeature.metaData["MountType"].includes(METADATA.Inner)) {
      //   dbFeature.metaData["MountType"].push(METADATA.Inner)
      // }
    }
    if (!dbFeature.metaData["MountHoles"]) {
      if (dbFeature.customDisplayName.includes("8 inch")) {
        dbFeature.metaData["MountHoles"] = ["8"]
      } else if (dbFeature.customDisplayName.includes("Single Hole")) {
        dbFeature.metaData["MountHoles"] = ["1"]
      } else if (dbFeature.customDisplayName.includes("Centerset")) {
        dbFeature.metaData["MountHoles"] = ["4"]
      } else if (dbFeature.s3Bindings) {
        console.log("NO FAUCET DBFEATURE META MountHoles!", dbFeature.customDisplayName);
      }
      // } else if(dbFeature.metaData["MountType"].includes(METADATA.Outer) && !dbFeature.metaData["MountType"].includes(METADATA.Inner)) {
      //   dbFeature.metaData["MountType"].push(METADATA.Inner)
      // }
    } else if (dbFeature.metaData["MountHoles"].includes("0")) {
      dbFeature.metaData["MountHoles"] = ["0", "1", "4", "8"]
    }
    if (Array.isArray(dbFeature.metaData["Height"]) && dbFeature.metaData["Height"][0]) {
      dbFeature.metaData["Height"] = +dbFeature.metaData["Height"][0]; // convert to number
    }
    if (dbFeature.isFromAsRoom) {

      if (!dbFeature.metaData["MountLevel"]) {
        if (Array.isArray(dbFeature.metaData["MountType"]) && dbFeature.metaData["MountType"][0]) {
          if (dbFeature.metaData["MountType"][0] === "U") {
            dbFeature.metaData["MountLevel"] = ["0"]
          } else if (dbFeature.metaData["MountType"][0] === "S") {
            dbFeature.metaData["MountLevel"] = ["2"]
          }
        } else {
          dbFeature.metaData["MountLevel"] = ["2"]
        }
      }

      if (dbFeature.metaData["MountType"].includes(METADATA.Outer)) {
        ["ST", "T", "W", "S", "A"].forEach(metaValue => {
          if (!dbFeature.metaData["MountType"].includes(metaValue)) {
            dbFeature.metaData["MountType"].push(metaValue);
          }
        })
      }
      if (dbFeature.metaData["MountType"].includes(METADATA.StandAlone) && !dbFeature.metaData["MountType"].includes(METADATA.Outer)) {
        dbFeature.metaData["MountType"].push(METADATA.Outer);
      }
    }
    // if (!dbFeature.metaData["SingleHole"]) {
    //   dbFeature.metaData["SingleHole"] = [dbFeature[getDbFeatureProperty("lixilProductSubCategory")]]; // todo change to filters
    // }
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    const partNumber = dbFeature.metaData["layerPosition"] === SIDE_POSITIONS[0] ? 1 : 2;
    return super.load_(dbFeature, new VanityFaucet(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  getMatchingSinks() { // method is used for feature, to find the same sink as the current one
    const faucetParent = this.getParent();
    const vanityParent = faucetParent.getParent();
    const sinkParent = vanityParent.sink;
    const layout = vanityParent.layout;
    const currentSinkNavItems = layout.designNavigationItems({part: sinkParent});
    const matchingByCabinetType = currentSinkNavItems.filter(navItem => {
      return faucetParent.getActiveFeatureConditions(this).every(condition => navItem.part.matchesMetaForCondition(condition.propName, condition.propValue))
    });
    const withCurrentVanityType = matchingByCabinetType.filter(navItem => {
      if (!vanityParent.vanity_type) {
        return navItem.part.metaData["MountType"] && navItem.part.metaData["MountType"].includes("ST")
      }
      return navItem.part.matchesMetaForCondition("CustomVanityType", vanityParent.vanity_type)
    });
    const {filterGroups} = store.getState().filterState;
    const sinkCollectionName = vanityParent.sink && vanityParent.sink.activeFeature
      ? vanityParent.sink.activeFeature.getCollectionName(filterGroups)
      : "";
    const sinkCustomFullDisplayName = vanityParent.sink && vanityParent.sink.activeFeature
      ? vanityParent.sink.activeFeature.getCustomFullDisplayName()
      : "";
    const sameCollectionName = !sinkCollectionName ? withCurrentVanityType : withCurrentVanityType.filter(navItem => {
      return navItem.part.getCollectionName(filterGroups) === sinkCollectionName
    });
    const sameCustomName = !sinkCustomFullDisplayName ? sameCollectionName : sameCollectionName.filter(navItem => {
      return navItem.part.getCustomFullDisplayName() === sinkCustomFullDisplayName
    });
    return {
      matchingByCabinetType,
      withCurrentVanityType,
      sameCollectionName,
      sameCustomName,
    }
  }

  getSinkToClickFromMatchingSinks = (sinkActiveFeature) => {
    const {
      matchingByCabinetType,
      withCurrentVanityType,
      sameCollectionName,
      sameCustomName,
    } = this.getMatchingSinks();
    // console.log("matchingByCabinetType", matchingByCabinetType);
    // console.log("withCurrentVanityType", withCurrentVanityType);
    // console.log("sameCollectionName", sameCollectionName);
    // console.log("sameCustomName", sameCustomName);
    const fromWhereToPick = sameCustomName.length
      ? sameCustomName
      : sameCollectionName.length
        ? sameCollectionName
        : withCurrentVanityType.length
          ? withCurrentVanityType
          : matchingByCabinetType;
    let featureToCLick = null;
    if (sinkActiveFeature) {
      const faucetParent = this.getParent();
      const vanityParent = faucetParent.getParent();
      const relatedItem = vanityParent.relatedItems.find(relItem => relItem.partId === vanityParent.vanity_type);
      if (relatedItem && relatedItem.activeFeature && sinkActiveFeature.metaData["MatchingFeature"]) {
        featureToCLick = fromWhereToPick.find(navItem => {
          return navItem.part.metaData["MatchingFeature"].includes(getSkuWithoutDot(relatedItem.activeFeature.dbFeature.sharedFeatureName))
        })
      }
      if (!featureToCLick) {
        featureToCLick = fromWhereToPick.find(navItem => navItem.part.getColorName() === sinkActiveFeature.getColorName())
      }
    }
    if (!featureToCLick) {
      featureToCLick = fromWhereToPick[0];
    }
    console.log("featureToCLick", featureToCLick);
    return featureToCLick ? featureToCLick.part : null;
  }

  handleClick(ignoreLocked = false) {
    const faucetParent = this.getParent();
    const vanityParent = faucetParent.getParent();
    const sinkParent = vanityParent.sink;

    if (!sinkParent.activeFeature || !sinkParent.activeFeature.matchesMetaForArrayOfConditions(faucetParent.getActiveFeatureConditions(this))) {
      const featureToCLick = this.getSinkToClickFromMatchingSinks(sinkParent.activeFeature)
      if (featureToCLick) {
        console.log("sink featureToCLick", featureToCLick);
        navFeatureCLick(featureToCLick, false, ignoreLocked, false);
      }
    }

    super.handleClick(ignoreLocked);
  }

  getCurrentSinkMetaData() {
    const sinkParent = this.getParent().sink;
    let metaObject = {};
    if (sinkParent && sinkParent.activeFeature) {
      const sinkMeta = sinkParent.activeFeature.metaData["MountType"];
      if (sinkMeta) {
        metaObject["MountType"] = Array.isArray(sinkMeta) ? sinkMeta[0] : sinkMeta
      }
      // const singleHoleMeta = sinkParent.activeFeature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")] === "Wall Hung Sinks" //
      // if (singleHoleMeta) {
      //   metaObject["SingleHole"] = METADATA.SingleHole
      // }
      const mountHolesMeta = sinkParent.activeFeature.metaData["MountHoles"] // American Standard
      if (mountHolesMeta && !(getCurrentRoomType() === LOOK_ROOM_TYPES.grohe && mountHolesMeta.includes("0"))) {
        metaObject["MountHoles"] = mountHolesMeta
      }
    }
    return metaObject
  }

  getArrayOfConditions(forNavigation = false) {
    // const counterTopSize = this.getParent().counterTopSize(this);
    // const conditions = [{
    //   propName: 'VanitySize',
    //   propValue: counterTopSize
    // }];
    const conditions = super.getArrayOfConditions();
    const currentSinkMetaData = this.getCurrentSinkMetaData();
    ["MountType", "MountHoles"].forEach(propName => {
      if ((!forNavigation || ((getCurrentRoomType() === LOOK_ROOM_TYPES.grohe) && propName === "MountType")) && currentSinkMetaData[propName]
        && !(propName === "MountHoles" && currentSinkMetaData[propName].includes("0") && currentSinkMetaData["MountType"] && currentSinkMetaData["MountType"].includes("U"))) {
        if (propName === "MountType" && (currentSinkMetaData[propName] === "V")) { // do not check V sinks
          return
        }
        conditions.push({
          propName,
          propValue: currentSinkMetaData[propName]
        })
      }
    })
    // if (currentSinkMetaData["SingleHole"]) {
    //   conditions.push({
    //     propName: 'SingleHole',
    //     propValue: currentSinkMetaData["SingleHole"]
    //   })
    // }
    const vanityParent = this.getParent();
    const activeSideMeta = vanityParent.getActiveMatchingMetaFromRelatedItem(vanityParent.vanity_type, "Side");
    if (activeSideMeta && activeSideMeta.includes("C") && !vanityParent.isDoubleVanity()) {
      conditions.push({
        propName: "Side",
        propValue: activeSideMeta
      });
    }
    // const countertopSize = vanityParent.counterTopSize(this);
    // if (countertopSize) {
    //   conditions.push({
    //     propName: "VanitySize",
    //     propValue: countertopSize && countertopSize[0] && (countertopSize[0] === "32") ? "48" : countertopSize
    //   })
    // }
    if (vanityParent.sink && vanityParent.sink.activeFeature) {
      const sinkType = vanityParent.sink.activeFeature.metaData["SinkType"]
      if (sinkType) {
        conditions.push({
          propName: "SinkType",
          propValue: vanityParent.sink.activeFeature.metaData["SinkType"]
        })
      }
      const mountLevel = vanityParent.sink.activeFeature.metaData["MountLevel"]
      if (mountLevel) {
        conditions.push({
          propName: "MountLevel",
          propValue: vanityParent.sink.activeFeature.metaData["MountLevel"]
        });
        if ((Array.isArray(mountLevel) && mountLevel[0] === "0") || mountLevel === "0") {
          const waterLevel = vanityParent.sink.activeFeature.metaData["WaterLevel"]
          if (waterLevel) {
            conditions.push({
              propName: "WaterLevel", // sink WaterLevel - is faucet Height, all logic is in the matchesMetaForCondition func
              propValue: vanityParent.sink.activeFeature.metaData["WaterLevel"]
            })
          }
        }
      }
    }
    // console.log("conditions", conditions);
    return conditions;
  }

  getActiveFeatureConditions(fromFeature = this.activeFeature) {
    let arrayOfConditions = this.getArrayOfConditions();
    arrayOfConditions = arrayOfConditions.map(condition => {
      if ((condition.propName === 'MountType' || condition.propName === 'MountHoles') && fromFeature.metaData[condition.propName]) {
        return {
          propName: condition.propName,
          propValue: fromFeature.metaData[condition.propName]
        }
      }
      return condition
    });
    if (fromFeature.metaData["MountLevel"]) {
      arrayOfConditions.push({
        propName: "MountLevel",
        propValue: fromFeature.metaData["MountLevel"]
      })
    }
    return arrayOfConditions
  }

  getAvailableFeatures() {
    return this.features.filter(f => f.matchesMetaForCondition('VanitySize', this.getParent().counterTopSize(this)));
  }

  handleChangeParent(nonCompatibleWith) {
    if (nonCompatibleWith === "sink") {
      this.getParent().getParent().sink.setActiveFeatureByFilter("MountType", METADATA.Inner)
    } else {
      this.getParent().getParent().vanityCabinet.setActiveFeatureByFilter("Size", this.metaData["VanitySize"] ? this.metaData["VanitySize"][0] : null); // "60in", etc.
    }
  }

  canDisplayDemoPoint(parentObject) {
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      return removeLookPointFor(parentObject, 6, "1", SIDE_POSITIONS[1])
    }
    return removeLookPointFor(parentObject, 3, "2", SIDE_POSITIONS[1])
      && removeLookPointFor(parentObject, 1, "1", SIDE_POSITIONS[1])
  }
}
